import { FC, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import SubmitBtn from 'src/component/ActionBtn/SubmitBtn'
import CostTag from 'src/component/CostTag'
import MedicinesSubmitionPopup from 'src/component/MedicinesPopup'
import PopupContainer from 'src/component/popup/PopupContainer'
import { Context } from 'src/context'
import { useMutation } from 'src/hooks/useMutation'
import { ApproveDoctorMedicineRequest, GetDoctorRequestMedicine } from 'src/requests/DoctorRequest'
import { errorToaster } from 'src/utils'

interface IAlterMedicinePopup {
    recordID: number | null
    modalID: any
    hospitalId: number | null
    isAllowModel56: boolean | null
}


const MedicinesPopup: FC<IAlterMedicinePopup> = ({ modalID, recordID, hospitalId, isAllowModel56 }) => {

    const { t } = useTranslation()

    const [totalCost, setTotalCost] = useState(0)

    const { ToggleReloadTable } = useContext(Context)

    const { state } = useLocation()

    const [medicineList, setMedicineList] = useState([])

    const { mutate: submit, isPending: isLoadingSubmit } = useMutation()

    //@ts-ignore
    useEffect(() => {
        if (!medicineList?.length) return
        //@ts-ignore
        let tempActiveTotalCost = medicineList.filter(item => item.isSelected).map(item => Number(item?.cost || 0)).reduce((nxt, cur) => nxt + cur, 0)
        //@ts-ignore
        let tempAltTotalCost = medicineList.filter(item => !item.isSelected && item.altMedicine && !item?.isDefault).map(item => Number(item?.altPrice || 0)).reduce((nxt, cur) => nxt + cur, 0)
        setTotalCost(tempActiveTotalCost + tempAltTotalCost)
    }, [medicineList])

    //@ts-ignore

    const handleCreateRequest = () => {
        //@ts-ignore
        let CheckedList = medicineList.filter(item => !!item?.isSelected).map(item => item.reqMedId)
        //@ts-ignore
        let AltList = medicineList.filter(item => !item?.isSelected)

        if (!CheckedList?.length && !AltList?.length) return errorToaster("please-select-one-item")

        let RequestBody = {
            requestId: recordID,
            requestMedicines: getRequestList(),
            alternativeMedicines: getAlternativeMedicines()
        }

        let requestSetup = {
            apiMethod: ApproveDoctorMedicineRequest,
            id: null,
            body: RequestBody,
            actionType: "post",
            name: 'order-review',
            onSuccess: handleReset,
        }
        //@ts-ignore
        submit(requestSetup)
    }

    const getRequestList = () => {

        let requestBodyMedicine = medicineList.map((item: any) => (
            {
                "requestMedicineId": item?.reqMedId,
                "isApproved": item?.isSelected
            }
        ))
        return requestBodyMedicine
    }

    const getAlternativeMedicines = () => {
        //@ts-ignore
        let CheckedList = medicineList.filter(item => !!item?.isSelected).map(item => item.reqMedId)
        //@ts-ignore
        let AltList = medicineList.filter(item => !item?.isSelected && item?.altMedicine?.value &&!item?.isDefault)

        if (!CheckedList?.length && !AltList?.length) return errorToaster("please-select-one-item")

        let mappedListForRequest = AltList.map((item: any) => ({
            altToRequestMedicineId: item?.reqMedId,
            AltMedicine: {
                medicineId: item?.altMedicine?.value,
                dosePerDay: item?.doseAmount,
                doseCountPerTime: item?.doseRepeat,
                doseTypeId: item?.userDoseRepeate?.value,
                duration: item?.duration,
                durationType: item?.durationType?.value,
                directAmount: item?.altMedicine?.allowDirectAmount ? item?.directAmount : null
            }
        })) || []

        return mappedListForRequest
    }

    const handleReset = () => {
        modalID.current.click()
        ToggleReloadTable((prev: boolean) => !prev)
        setMedicineList([])
    }

    const ApplyAction = (list: []) => {
        if (recordID && !list.length) {
            modalID.current.click()
            errorToaster("request-did-not-have-medicines")
        }
    }

    return (
        <>
            <PopupContainer
                recordID={recordID}
                Name={"order-review"}
                modalName="ChangeMedicine"
                modalID={modalID}
                AdditionalTitle={`${recordID}`}>

                <div className='row'>
                    <CostTag amount={totalCost} title={"total-cost"} />
                </div>
                <MedicinesSubmitionPopup isManual recordID={recordID} hospitalId={hospitalId} applyAction={ApplyAction} title={"order-review"} ApproveDoctorRequest={isAllowModel56} medicineList={medicineList} setMedicineList={setMedicineList} ApiMethod={GetDoctorRequestMedicine} isParamsValid={!!recordID} depArrItems={[recordID]} params={[recordID, hospitalId, state?.pharmName?.value]} defaultValue={[]} />
                <div className='row'>
                    <div className='col-sm-6 m-auto'>
                        <SubmitBtn label={t('renew-request')} onSubmit={handleCreateRequest} loading={isLoadingSubmit} />
                    </div>

                </div>
            </PopupContainer>
        </>
    )
}

export default MedicinesPopup